const sources = new WeakMap();
export function prefetchCryptoDepositSource(client, surface, locale, createId = () => crypto.randomUUID()) {
    const records = sourceRecords(client);
    const existing = records.get(surface);
    if (existing && !isTerminal(existing.operation))
        return existing.promise;
    const provider = client.cryptoDeposit;
    if (!provider)
        return Promise.reject(new Error('crypto_deposit_unavailable'));
    const record = {
        operation: null,
        promise: provider.create({ idempotencyKey: createId(), surface, locale }),
    };
    record.promise = record.promise
        .then((operation) => {
        record.operation = operation;
        return operation;
    })
        .catch((error) => {
        if (records.get(surface) === record)
            records.delete(surface);
        throw error;
    });
    records.set(surface, record);
    return record.promise;
}
export function peekCryptoDepositSource(client, surface) {
    const operation = sources.get(client)?.get(surface)?.operation ?? null;
    return isTerminal(operation) ? null : operation;
}
export function rememberCryptoDepositSource(client, surface, operation) {
    const record = sources.get(client)?.get(surface);
    if (!record || record.operation?.operationId !== operation.operationId)
        return;
    if (isTerminal(operation)) {
        sources.get(client)?.delete(surface);
        return;
    }
    record.operation = operation;
    record.promise = Promise.resolve(operation);
}
export function forgetCryptoDepositSource(client, surface) {
    sources.get(client)?.delete(surface);
}
function sourceRecords(client) {
    const existing = sources.get(client);
    if (existing)
        return existing;
    const records = new Map();
    sources.set(client, records);
    client.onDispose(() => sources.delete(client));
    return records;
}
function isTerminal(operation) {
    return Boolean(operation && ['complete', 'route_failed', 'refund'].includes(operation.state));
}
